import React from "react";

// Global view mode: true = show DATA (numbers/tables), false = show CHARTS.
// Default: DATA (per user request).
const ViewModeContext = React.createContext({ showData: true, toggle: () => {} });

export function ViewModeProvider({ children }) {
  const [showData, setShowData] = React.useState(true);
  const value = React.useMemo(
    () => ({ showData, toggle: () => setShowData((v) => !v), setShowData }),
    [showData],
  );
  return <ViewModeContext.Provider value={value}>{children}</ViewModeContext.Provider>;
}

export function useViewMode() {
  return React.useContext(ViewModeContext);
}
